export enum Feature {
  FindSpecification = "FindSpecification"
}
